import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('libs/draco/gltf/');
const loader = new GLTFLoader().setPath('model/gltf/');
loader.setDRACOLoader(dracoLoader);

//文字
const fontLoader = new FontLoader();
let font = null;
let fontMaterial = null;
export const loadFontModel = (text, size, callback) => {
  if (!font) {
    fontLoader.load('fonts/helvetiker_regular.typeface.json', function (eFont) {
      font = eFont;
      callback(createText(text, size, font));
    });
  } else {
    callback(createText(text, size, font));
  }
};

function createText(text, size = 0.3, font) {
  const geometry = new TextGeometry(text, {
    font: font,
    size: size,
    height: 0.05,
  });
  geometry.computeBoundingBox();
  if (!fontMaterial)
    fontMaterial = new THREE.MeshBasicMaterial({
      color: 0xed1941,
      side: THREE.DoubleSide,
    });
  fontMaterial.transparent = true;
  fontMaterial.depthTest = false;

  let mesh = new THREE.Mesh(geometry, fontMaterial);
  return mesh;
}